<template>

  <div>
    {{ countdown }}
  </div>

</template>

<script>
export default {
  props: ['candidate'],
  beforeDestroy() {
    clearInterval(this.interval)
  },
  data() {
    return {
      countdown: null,
      interval: null
    }
  },
  methods: {
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
  },
  created() {
    const cookie = this.getCookie(`last-resent-at-${this.candidate.id}`)

    if (cookie) {
      const expirationTime = new Date(this.getCookie(`last-resent-at-${this.candidate.id}`));

      this.interval = setInterval(() => {

        const remainingTime = Math.floor((expirationTime - new Date()) / 1000);

        if (remainingTime < 0) {
          clearInterval(this.interval);
          this.countdown = null
          this.$emit('expired', this.candidate)
          return
        }
        
        const minutes = Math.floor(remainingTime / 60).toString().padStart(2, "0");
        const seconds = (remainingTime % 60).toString().padStart(2, "0");
        this.countdown = `${minutes}:${seconds}`

      }, 1000);
    }
  }
}
</script>